import { Component, input, output } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import type {
  SingleAnswerQuestion,
  SingleAnswerQuestionOption,
} from '../models/single-answer-question.interface';
import type { QuestionnaireInfoModalTarget } from '../models/questionnaire-target.interface';

@Component({
  selector: 'wl-questionnaire-question-single',
  standalone: true,
  imports: [AutomationIdDirective, FontAwesomeModule],
  templateUrl: './questionnaire-question-single.component.html',
  styleUrls: [
    './questionnaire-question-single.component.ed.scss',
    './questionnaire-question-single.component.essent.scss',
  ],
})
export class QuestionnaireQuestionSingleComponent {
  public readonly questionData = input.required<SingleAnswerQuestion>();
  public readonly showPrevious = input(false);
  public readonly rendering = {
    questionTitle: 'Vragen over je woning',
    previousLabel: 'Vorige vraag',
  };
  public requestInfo = output<QuestionnaireInfoModalTarget>();
  public submitAnswer = output<SingleAnswerQuestionOption>();
  public back = output<void>();
}
